import React from "react";
import SanDiegoSunsetPage from "./SanDiegoSunsetPage";

export default function SaluteSocialCaliforniaWildAles() {
  return (
    <SanDiegoSunsetPage
      eventName="San Diego Salute & Social"
      pageTitle="San Diego Salute & Social"
    />
  );
}
